import { render, staticRenderFns } from "./uWork-prove.vue?vue&type=template&id=5bac70e4&scoped=true"
import script from "../../assets/ts/prove-view/uWork-prove.ts?vue&type=script&lang=ts&external"
export * from "../../assets/ts/prove-view/uWork-prove.ts?vue&type=script&lang=ts&external"
import style0 from "./uWork-prove.vue?vue&type=style&index=0&id=5bac70e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bac70e4",
  null
  
)

export default component.exports